import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DatePickerComponent,
      multi: true
    }
  ]
})
export class DatePickerComponent implements OnInit, ControlValueAccessor {

  @Input()
  labelText: string;

  @Input()
  placeholder: string;

  @Input()
  required: boolean;

  @Input()
  minDate: Date | undefined;

  @Input()
  maxDate: Date | undefined;

  @Input()
  submitted: boolean;

  warningLabel: string;
  dateModel: string;
  onChange!: (value: any) =>  void;

  constructor(private rf: ChangeDetectorRef) { 
    this.labelText = '';
    this.placeholder = '';
    this.required = false;
    this.submitted = false;
    this.dateModel = '';
    this.warningLabel = '';
  }

  writeValue(obj: any): void {
    this.dateModel = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
  }

  ngOnInit(): void {
  }

  validate(): boolean {

    if (!this.submitted) {
      return true;
    }

    if (this.required && !this.dateModel) {
      this.warningLabel = `Ingrese su ${this.labelText}.`;
      return false;
    }

    return true;
  }

}


